module.exports = __webpack_public_path__ + "img/index-t-slide1.303949ab.jpg";